import { lazy } from "react";

export const HomePage = lazy(() => import("./home"));
export const LoginPage = lazy(() => import("./auth/login"));
